import { render } from "./Wordmark.vue?vue&type=template&id=18e21b16"
const script = {}

import "./Wordmark.vue?vue&type=style&index=0&id=18e21b16&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__